import { render } from "./userAgreement.vue?vue&type=template&id=d50ddda4&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=d50ddda4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50ddda4"]])

export default __exports__